var _path, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 89,
    viewBox: "0 0 95 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.5464 10.5919L54.3575 3.86227C45.2208 1.42125 38.4677 5.33414 36.0115 14.4741L27.6926 45.4301C25.1961 54.7199 29.1145 61.3554 38.2512 63.7964L63.4401 70.5261C72.724 73.0065 79.2946 69.1733 81.7911 59.8835L90.11 28.9275C92.5662 19.7875 88.8303 13.0723 79.5464 10.5919Z",
    fill: "url(#paint0_linear_3710_27982)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_3710_27982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.965 19.0689L55.8036 14.4839C49.5787 12.8208 44.9777 15.4867 43.3043 21.7139L37.6365 42.8045C35.9357 49.1337 38.6053 53.6546 44.8302 55.3177L61.9916 59.9027C68.3169 61.5925 72.7935 58.981 74.4944 52.6517L80.1621 31.5611C81.8356 25.334 79.2902 20.7588 72.965 19.0689Z",
    fill: "#39B93A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_3710_27982)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_3710_27982",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 15.6093,
    width: 74,
    height: 74,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    y: 15.6093,
    width: 74,
    height: 74
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3369 16.6093H21.2985C9.16235 16.6093 1 25.1048 1 37.7409V66.904C1 79.5045 9.16235 88 21.2985 88H52.3369C64.473 88 72.5996 79.5045 72.5996 66.904V37.7409C72.5996 25.1048 64.473 16.6093 52.3369 16.6093Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.3369 16.6093H21.2985C9.16235 16.6093 1 25.1048 1 37.7409V66.904C1 79.5045 9.16235 88 21.2985 88H52.3369C64.473 88 72.5996 79.5045 72.5996 66.904V37.7409C72.5996 25.1048 64.473 16.6093 52.3369 16.6093Z",
    fill: "#39B93A",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3369 17.6093C52.8892 17.6093 53.3369 17.1616 53.3369 16.6093C53.3369 16.057 52.8892 15.6093 52.3369 15.6093V17.6093ZM52.3369 15.6093C51.7846 15.6093 51.3369 16.057 51.3369 16.6093C51.3369 17.1616 51.7846 17.6093 52.3369 17.6093V15.6093ZM52.3369 15.6093H21.2985V17.6093H52.3369V15.6093ZM21.2985 15.6093C14.9886 15.6093 9.64322 17.8233 5.87703 21.7438C2.11419 25.6608 0 31.2053 0 37.7409H2C2 31.6405 3.96698 26.6191 7.31935 23.1293C10.6684 19.6431 15.4723 17.6093 21.2985 17.6093V15.6093ZM0 37.7409V66.904H2V37.7409H0ZM0 66.904C0 73.4226 2.11464 78.9581 5.87745 82.8704C9.64352 86.7861 14.9886 89 21.2985 89V87C15.4722 87 10.6681 84.9662 7.31893 81.484C3.96653 77.9984 2 72.986 2 66.904H0ZM21.2985 89H52.3369V87H21.2985V89ZM52.3369 89C58.6469 89 63.9836 86.7859 67.7409 82.8695C71.4946 78.9568 73.5996 73.4214 73.5996 66.904H71.5996C71.5996 72.9872 69.6412 77.9998 66.2977 81.4849C62.9577 84.9663 58.163 87 52.3369 87V89ZM73.5996 66.904V37.7409H71.5996V66.904H73.5996ZM73.5996 37.7409C73.5996 31.2065 71.4951 25.6622 67.7413 21.7447C63.9839 17.8234 58.647 15.6093 52.3369 15.6093V17.6093C58.1629 17.6093 62.9574 19.6429 66.2972 23.1284C69.6408 26.6177 71.5996 31.6392 71.5996 37.7409H73.5996Z",
    fill: "url(#paint1_linear_3710_27982)",
    mask: "url(#path-3-outside-1_3710_27982)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_3710_27982)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_3710_27982",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5502 63.8983C31.7483 63.8983 30.9464 63.5949 30.3342 62.9845L21.8389 54.514C20.6146 53.2932 20.6146 51.3156 21.8389 50.0984C23.0633 48.8777 25.043 48.8741 26.2674 50.0949L32.5502 56.3594L47.3284 41.6244C48.5527 40.4036 50.5324 40.4036 51.7568 41.6244C52.9812 42.8451 52.9812 44.8227 51.7568 46.0434L34.7662 62.9845C34.154 63.5949 33.3521 63.8983 32.5502 63.8983Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.5502 63.8983C31.7483 63.8983 30.9464 63.5949 30.3342 62.9845L21.8389 54.514C20.6146 53.2932 20.6146 51.3156 21.8389 50.0984C23.0633 48.8777 25.043 48.8741 26.2674 50.0949L32.5502 56.3594L47.3284 41.6244C48.5527 40.4036 50.5324 40.4036 51.7568 41.6244C52.9812 42.8451 52.9812 44.8227 51.7568 46.0434L34.7662 62.9845C34.154 63.5949 33.3521 63.8983 32.5502 63.8983Z",
    fill: "url(#paint2_linear_3710_27982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8389 50.0984L21.9799 50.2403L21.9801 50.2401L21.8389 50.0984ZM32.5502 56.3594L32.409 56.501L32.5502 56.6418L32.6914 56.501L32.5502 56.3594ZM51.7568 46.0434L51.6156 45.9018L51.7568 46.0434ZM34.7662 62.9845L34.9074 63.1261L34.7662 62.9845ZM32.5502 63.6983C31.7987 63.6983 31.0484 63.4141 30.4754 62.8428L30.193 63.1261C30.8444 63.7756 31.6979 64.0983 32.5502 64.0983V63.6983ZM30.4754 62.8428L21.9801 54.3723L21.6977 54.6556L30.193 63.1261L30.4754 62.8428ZM21.9801 54.3723C20.834 53.2296 20.8343 51.3792 21.9799 50.2403L21.6979 49.9566C20.3948 51.2521 20.3951 53.3568 21.6977 54.6556L21.9801 54.3723ZM21.9801 50.2401C23.1267 49.0968 24.9801 49.0938 26.1261 50.2365L26.4086 49.9532C25.1059 48.6543 22.9998 48.6585 21.6977 49.9568L21.9801 50.2401ZM26.1261 50.2365L32.409 56.501L32.6914 56.2178L26.4086 49.9532L26.1261 50.2365ZM32.6914 56.501L47.4696 41.766L47.1872 41.4827L32.409 56.2178L32.6914 56.501ZM47.4696 41.766C48.6159 40.623 50.4693 40.623 51.6156 41.766L51.898 41.4827C50.5956 40.1841 48.4896 40.1841 47.1872 41.4827L47.4696 41.766ZM51.6156 41.766C52.7616 42.9086 52.7616 44.7592 51.6156 45.9018L51.898 46.1851C53.2007 44.8861 53.2007 42.7817 51.898 41.4827L51.6156 41.766ZM51.6156 45.9018L34.625 62.8428L34.9074 63.1261L51.898 46.1851L51.6156 45.9018ZM34.625 62.8428C34.0521 63.4141 33.3017 63.6983 32.5502 63.6983V64.0983C33.4026 64.0983 34.256 63.7756 34.9074 63.1261L34.625 62.8428Z",
    fill: "url(#paint3_linear_3710_27982)",
    fillOpacity: 0.5,
    mask: "url(#path-5-inside-2_3710_27982)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3710_27982",
    x: 23.1338,
    y: -0.000823975,
    width: 71.5298,
    height: 74.4059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_3710_27982"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_3710_27982",
    x: -24,
    y: -8.39072,
    width: 121.6,
    height: 121.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3710_27982"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3710_27982",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_3710_27982",
    x: 5.92065,
    y: 25.7088,
    width: 61.7544,
    height: 53.1895,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3710_27982"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454902 0 0 0 0 0.870588 0 0 0 0 0.376471 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_3710_27982",
    result: "effect2_dropShadow_3710_27982"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3710_27982",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3710_27982",
    x1: 93.9997,
    y1: 14.4534,
    x2: 39.1552,
    y2: 48.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B93A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B8F0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3710_27982",
    x1: 12.3975,
    y1: 24.9264,
    x2: 57.909,
    y2: 81.4584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3710_27982",
    x1: 50.4237,
    y1: 44.8963,
    x2: 15.0851,
    y2: 46.4741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3710_27982",
    x1: 24.3413,
    y1: 48.4877,
    x2: 51.3045,
    y2: 48.6915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.3857af06d165322ca0516e660bf52136.svg";
export { ForwardRef as ReactComponent };